import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PartyRSVP from './pages/PartyRSVP';
import BackgroundParticles from './components/BackgroundParticles';
import './App.css';
import { AnimatePresence, motion } from 'framer-motion';

class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };
  
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      return <div>Error: {this.state.error?.message}</div>;
    }
    return this.props.children;
  }
}

function AnimatedRoutes() {
  const location = useLocation();
  
  return (
    <AnimatePresence mode="wait">
      <motion.main
        key={location.pathname}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
      >
        <ErrorBoundary>
          <Routes location={location}>
            <Route path="/" element={<PartyRSVP />} />
          </Routes>
        </ErrorBoundary>
      </motion.main>
    </AnimatePresence>
  );
}

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BackgroundParticles />
        <AnimatedRoutes />
      </div>
    </AuthProvider>
  );
}

export default App;
